import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { getBookAuthor } from "../../store/actions/book";
import { authCheckState } from "../../store/actions/auth";
import { getSetting } from "../../store/actions/setting";
const useStyles = (theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "44ch",
    },
  },
  DateField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
});
class LivePreviewExample extends React.Component {
  render() {
    return (
      <div className="cube-wrapper" style={{ fontFamily: "arial" }}>
        <div className="cube-folding">
          <span className="leaf1" />
          <span className="leaf2" />
          <span className="leaf3" />
          <span className="leaf4" />
        </div>
        <span className="loading" data-name="Loading">
          Loading
        </span>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    authors: state.book.authors,
    books: state.book.books,
    racks: state.book.racks,
    rooms: state.book.rooms,
    userId: state.auth.userId,
    editions: state.book.editions,
    categorys: state.book.categorys,
    subcategorys: state.book.subcategorys,
    token: state.auth.token,
    loading: state.book.loading,
    error: state.book.error,
    isAuthenticated: state.auth.token !== null,
    successAuth: state.auth.successAuth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ongetBookAuthor: (token) => dispatch(getBookAuthor(token)),
    authCheckState: () => dispatch(authCheckState()),
    getSetting: (token) => dispatch(getSetting(token)),
  };
};

export default compose(
  withStyles(useStyles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps)
)(LivePreviewExample);
